import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';
import type { CompanyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';

import { useGetCompaniesMutation } from '../apis';

export function AsyncCompanySelector({ disabled, ...props }: FormAsyncComboboxProps<CompanyQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: CompanyQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName =
        item?.account_number && item?.account_number > 0 ? `${item.account_number} - ${item.name}` : item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/companies/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetCompaniesMutation}
      disabled={disabled}
    />
  );
}
